var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"user-select":"none"},style:({
      'max-width': _vm.maxWidth + 'px !important',
    })},[_c('v-card',{staticClass:"grey",staticStyle:{"overflow":"hidden","border-radius":"4px"}},[_c('v-card-text',{staticStyle:{"height":"200px"}})],1),_vm._v(" "),_c('v-card',{staticStyle:{"position":"relative","top":"-34px","opacity":"0.7","border-radius":"0 0 4px 4px"},attrs:{"dark":""}},[_c('v-card-title',{staticClass:"white ticker pa-1"},[_c('q',{staticClass:"animated-ticker black--text"},[_vm._v(_vm._s(_vm.extendedTickerMessage))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/TickerPreview.vue?vue&type=template&id=5c19494a&scoped=true&
// module id = 1818
// module chunks = 5